export default {
  data() {
    return {
      text: "Copiar",
      copyText: '',
      loading: false,
      presentaciones: [],
      search: "",
      item: null,
      headers: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        // {
        //   text: "Total facturas Q.",
        //   align: "end",
        //   sortable: true,
        //   value: "total_fatura"
        // },
        // {
        //   text: "Total Retenciones Q.",
        //   align: "end",
        //   sortable: true,
        //   value: "total_retencion"
        // },
        // {
        //   text: "Pago de impuesto Q.",
        //   align: "end",
        //   sortable: true,
        //   value: "pago"
        // },
        {
          text: "Facturas",
          align: "center",
          sortable: true,
          value: "facturas"
        },
        {
          text: "Retenciones",
          align: "center",
          sortable: true,
          value: "retenciones"
        },
        {
          text: "# de Registro de Colaborador TIC",
          align: "center",
          sortable: true,
          value: "asignado_id"
        },
        {
          text: "Colaborador TIC asignado",
          align: "center",
          sortable: true,
          value: "asignado"
        },
        {
          text: "Correo de Recordatorio de pago",
          value: "recordatorio"
        },
        {
          text: "Correo de Finalización de la declaración",
          align: "center",
          sortable: true,
          value: "correo"
        },
        {
          text: "Pago realizado",
          align: "center",
          sortable: true,
          value: "pago_realizado"
        },
      ],
      fecha: {
        fecha: "",
        fecha_usuario: "",
      },
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      tab: null,
      tipoRegimen: [],
      tipo_id: 1,
      tipo_nombre: 'Pequeño Contribuyente',
      temp_table: false,
    };
  },
  async created() {
    console.log("reporte_declaraciones.created");
    await this.getRegimenListado();
    // await this.listadoPendientesPago();
  },
  methods: {
    async filtarInformacion(id, descripcion) {
      console.log("filtrarInformacion");
      this.tipo_id = id;
      this.tipo_nombre = descripcion;
      await this.listadoPendientesPago();
      this.temp_table = true;
    },
    async getRegimenListado() {
      console.log("getRegimenListado");
      try {
        let r = await this.$store.state.services.administradorService.getRegimenListado();
        this.tipoRegimen = r.data.data;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener los tipos de regímen")
      }
    },
    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },
    reset() {
      this.copyText = this.text
    },
    async copyCode(item) {
      await navigator.clipboard.writeText(item);
      this.copyText = "Copiado"
    },
    async pagoFacturas(item) {
      console.log('pagoFacturas');
      try {
        this.loading = true;
        let r =
          await this.$store.state.services.presentacionService.pagoFacturas(item.id);
        if (r.status === 200) {
          this.$toast.success(
            "EL PAGO HA SIDO REALIZADO EXITOSAMENTE"
          );
          await this.listadoPendientesPago();
        } else {
          this.$toast.error(
            "Ocurrió un error al intentar realizar el pago"
          );
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toast.error(
          "Ocurrió un error al intentar realizar el pago: " + error);
      }
    },
    allowedDates: (date) => date <= (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    async listadoPendientesPago() {

      this.fecha.fecha_usuario = this.date.split("-")
        .reverse()
        .join("/");

      this.fecha.fecha = this.date;
      this.fecha.regimen_id = this.tipo_id;
      try {
        this.loading = true;
        let r =
          await this.$store.state.services.presentacionService.listadoPendientesPago(this.fecha);
        this.presentaciones = r.data.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toast.error(
          "Ocurrió un error al obtener el listado de declaraciones "
        );
      }
    },
    async correoFinalizacionPresentacion(item) {
      try {
        this.loading = true;
        let body = {
          presentacion_id: item.id,
          impuesto_isr: item.pago,
          impuesto_iva: item.impuesto_pagar_debitos,
        };

        let r =
          await this.$store.state.services.presentacionService.correoFinalizacionPresentacion(body);
        if (r.status === 200) {

          this.$toast.success(
            "Se ha concluido el proceso y se ha enviado correo de notificación al usuario"
          );
          await this.listadoPendientesPago();
        } else {
          this.$toast.error(
            "Ocurrió un error al intentar enviar el correo"
          );
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toast.error(
          "Ocurrió un error al intentar enviar el correo: " + error,
          "ERROR"
        );
      }
    },
    async recordatorio(item) {
      try {
        this.loading = true;
        let r =
          await this.$store.state.services.usuarioService.recordatorio(item.id);
        if (r.status === 200) {
          this.$toast.success(
            "Se ha enviado el correo exitosamente"
          );
        } else {
          this.$toast.error(
            "Ocurrió un error al intentar enviar el correo"
          );
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toast.error(
          "Ocurrió un error al intentar enviar el correo: " + error,
          "ERROR"
        );
      }
    }
  },
  async mounted() {
    console.log("/reporte_declaracion");
  },
};